import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notice-box"
}
const _hoisted_2 = { class: "box" }
const _hoisted_3 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackNotice',
  props: {
    content: {
        type: Array,
        default: () => []
    },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (__props.content?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index,
              innerHTML: item
            }, null, 8, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})